import {TGameMessage} from "modules/reducers/game_message";
import {createAction} from "redux-act";

export const showGameMessage = createAction<Partial<TGameMessage>>('showMessage');
export const hideGameMessage = createAction('hideMessage');